import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isRegistered: false,
  registrationStatus: "idle",
  error: null,
};

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    registrationRequest(state) {
      state.registrationStatus = "loading";
    },
    registrationSuccess(state) {
      state.isRegistered = true;
      state.registrationStatus = "succeeded";
    },
    registrationFail(state, action) {
      state.registrationStatus = "failed";
      state.error = action.payload;
    },
    resetRegistrationStatus(state) {
      state.registrationStatus = "idle";
      state.error = null;
    },
  },
});

export const {
  registrationRequest,
  registrationSuccess,
  registrationFail,
  resetRegistrationStatus,
} = registerSlice.actions;
export default registerSlice.reducer;
